import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root"
})
export class AuthService {
  public binValidatedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  reloadTemplate = new EventEmitter<any>();

	constructor (private http: HttpClient) {}

  get(endpoint, params?) {
		return this.http.get(endpoint, params);
	}

	post(endpoint, body, params?) {
		return this.http.post(endpoint, body, params);
	}

	delete(endpoint, params?){
		return this.http.delete(endpoint, params);
	}
	getUser(userId) {
		return this.http.get<any>(environment.apiUrlCsV1 + 'users/' + userId, {})
			.pipe(
				map(res => res || res),
				catchError(error => throwError(error))
			);
	}
	getUserDetails() {
		return this.http.get<any>(environment.apiUrlCsV1 + 'user', {})
			.pipe(
				map(res => res || res),
				catchError(error => throwError(error))
			);
	}


	getCards(params = {}) {
		return this.http.get<any>(environment.apiUrlCsV1 + 'user/user_cards', {
			params: params
		})
			.pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);
	}

	binValidation(bin) {
		return this.http.get<any>(environment.apiUrlPsV1 + "/bins/card_details?bin=" + bin).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		)
	}
	cardValidation(bin) {
		return this.http.post<any>(environment.apiUrlCsV1 + "bins/validate", {bin: bin}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		)
	}
	addCard(bin, bin_type ){
		return this.http.post<any>(environment.apiUrlCsV1 + "user/user_cards", {bin: bin, bin_type : bin_type }).pipe(
		  map(res => res || []),
		  catchError(error => throwError(error))
		);
	}
	validateCard(bin, bin_type = "first8") {
		return this.http.post<any>(environment.apiUrlCsV1 + "user/user_cards/search",{bin:bin, bin_type:bin_type}).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}

	createTokenUser(token, uid?, client?,attr = 'token') {
		let params = {};
		if (token) params[attr] = token;
		if (uid) params['uid'] = uid;
		if (client) params['client'] = client;

			return this.http.post(environment.apiUrlCsV1 + "sessions", params).pipe(
				map(res => res || []),
				catchError(error => throwError(error))
			);

	}

	checkCardEligibility(bin, bin_type, bundle_id) {
		return this.http.get(environment.apiUrlPsV1 + "/bins/validate?bin=" + bin + "&bundle_id=" + bundle_id).pipe(
			map(res => res || []),
			catchError(error => throwError(error))
		);
	}
  
  addLocation(params) {
    return this.http.post<any>(environment.apiUrlCsV1 + "user/user_locations/log", params).pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  validateExistingUser(mobile: string, calling_code = '', userCountry_id) {
    let httpOptions = {}
		httpOptions = {
		  headers: new HttpHeaders({
			'X-Country-Id': userCountry_id
		  })
		}

    if (calling_code == '') {
      return this.http.post<any>(environment.apiUrlCsV1 + 'users/search', { mobile }, httpOptions)
        .pipe(
          map(res => {
            return res;
          }),
          catchError((err: HttpErrorResponse) => {
            return throwError(err);
          })
        );
    }
    else {
      return this.http.post<any>(environment.apiUrlCsV1 + 'users/search', { mobile, calling_code }, httpOptions)
        .pipe(
          map(res => {
            return res;
          }),
          catchError((err: HttpErrorResponse) => {
            return throwError(err);
          })
        );
    }
  }
  requestUserOtp(mobile: string, userId: string) {
    return this.http.post<any>(environment.apiUrlCsV1 + 'users/' + userId + '/otps', { mobile: mobile, otp_type: "login" })
      .pipe(
        map(res => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err);
        })
      );
  }
  validateUserOtp(userId: string, otp: string, otpType: string, mobileNum?: any) {
    return this.http.post<any>(environment.apiUrlCsV1 + 'users/' + userId + '/otps/verify', { otp_type: otpType, code: otp })
      .pipe(
        map(res => {
          var user = {
            id: userId,
            token: res.token
          }
          if (mobileNum) {
            user['mobile'] = mobileNum;
          }
          if (user && user.token) {
            localStorage.setItem('currentUser', JSON.stringify(user));
          }
          return user;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err);
        })
      );
  }
  logout(reload = true) {
    let cookiePolicy = localStorage.getItem("cookiePolicy");
    let userCountry = localStorage.getItem("userCountry");
    let allCountries = localStorage.getItem("allCountries");
    localStorage.clear();
    sessionStorage.clear();
    this.binValidatedSubject.next(false);
    if(cookiePolicy){
      localStorage.setItem('cookiePolicy', cookiePolicy);
    }
    if(reload){
      location.reload();
    }
    else {
      if(userCountry){
        localStorage.setItem('userCountry', userCountry);
      }
      if(allCountries){
        localStorage.setItem('allCountries', allCountries);
      }
    }
  }

  isAuthenticated() {
    if (sessionStorage.getItem('userVerifiedBin')) {
      return true;
    }
    else{
      return false;
    }
  }
  addUserCard(bin) {
    return this.http.post(environment.apiUrlCsV1 + 'user/user_cards', { bin: bin, bin_type: 'first8' });
  }

  deleteToken() {
    if (JSON.parse(localStorage.getItem('login_details'))) {
      const currentUserId = JSON.parse(localStorage.getItem('login_details')).id;
      return this.http.post(environment.apiUrlCsV1 + 'sessions/' + currentUserId, {}).toPromise();
    }
  }
  createUser(mobile: string, email: string, calling_code: string = "default", userCountry_id) {
    let httpOptions = {}
		httpOptions = {
		  headers: new HttpHeaders({
			'X-Country-Id': userCountry_id
		  })
		}
    if (calling_code == 'default') {
      return this.http.post<any>(environment.apiUrlCsV1 + 'users', { mobile: mobile, email: email }, httpOptions)
        .pipe(
          map(res => {
            return res;
          }),
          catchError((err: HttpErrorResponse) => {
            return throwError(err);
          })
        );
    }
    else {

      return this.http.post<any>(environment.apiUrlCsV1 + 'users', { mobile: mobile, email: email, calling_code }, httpOptions)
        .pipe(
          map(res => {
            return res;
          }),
          catchError((err: HttpErrorResponse) => {
            return throwError(err);
          })
        );
    }

  }
}
